<template>
    <div class="Project" id="a4">
        <div class="Project-title"> {{Title}} </div>
        <div class="Project-subheading"> {{Subheading}} </div>
        <div class="Project-content-bg">
            <div class="Project-left">
                <el-carousel height="442px" indicator-position="none" :arrow="Items[State.Select].Images.length > 1?'hover':'never'">
                  <el-carousel-item v-for="(image, index) in Items[State.Select].Images" :key="index">
                      <el-image :src="image"></el-image>
                  </el-carousel-item>
                </el-carousel>
            </div>
            <div class="Project-right">
                <div v-for="(item, index) in Items" :key="index">
                    <button :class="ButtonStyles[index == State.Select? 0:1]" @click="State.Select=index">
                        <div class="Project-right-sbutton-title"> {{item.Title}} </div>
                        <div class="Project-right-sbutton-content"> {{item.Subheading}} </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components:{
        
    },

    data() {
        return {
            State: this.$store.state.projectSelectState,
            ButtonStyles:["Project-right-sbutton", "Project-right-dbutton"],
            Title: "行业解决方案",
            Subheading: "为商家提供全方位一站式服务",
            Items: [
                {
                    Title: "珠宝门店",
                    Subheading: "线下店应该搭配线上店，线下导购应该也是线上顾问。凭借私域，实现坪效和人效的突破。",
                    Images: [
                        require("../assets/img/home/project_image1.png"),
                    ],
                },
                {
                    Title: "电商行业",
                    Subheading: "直连消费者，已经成为品牌必修课。宝来客助力品牌商搭建完整的私域电商体系。",
                    Images: [
                        require("../assets/img/home/product_dshy1.png"),
                    ],
                },
                {
                    Title: "网红主播",
                    Subheading: "把公域流量变成私域「留量」，是主播常青树的秘密。私域公域相互导流，良性循环。",
                    Images: [
                        require("../assets/img/home/project_whzb1.png"),
                    ],
                },
            ],
        }
    },
    mounted(){
        
    },
    methods:{
    }
}
</script>

<style lang="scss" scoped>
.el-button--primary.is-plain {
    color:#514D66;
    background-color: #F4F4F9;
    border-color: #F4F4F9;
}
.Project {
    width: 100%;
    height: 800px;
    margin: 0 auto;
    &-title {
        color: #211C39;
        padding-top: 100px;
        font-size: 34px;
        text-align: center;
        font-weight: 800;
    }
    &-subheading {
        color: #514D66;
        font-size: 20px;
        text-align: center;
        padding: 20px 0px 60px 0px;
    }
    &-content-bg {
        display: flex;
        width: 1400px;
        height: 442px;
        margin: 0 auto;
        margin-top: 0px;
    }
    &-left {
        width: 758px;
        height: 442px;
    }
    &-right {
        height: 442px;
        width: 616px;
        margin-left: 26px;
        margin-top: -28px;
        &-sbutton {
            width: 616px;
            height: 130px;
            margin-top: 28px;
            text-align: left;
            background-color: #7E49FE;
            color: #fff;
            border: 0px;
            border-radius: 6px;
            &-title {
                font-size: 22px;
                font-weight: 800;
                line-height: 22px;
                margin-left: 15px;
            }
            &-content {
                font-size: 16px;
                font-weight: 400;
                max-width: 576px;
                line-height: 26px;
                white-space: normal;
                margin-top: 16px;
                margin-left: 15px;
            }
        }
        &-dbutton {
            width: 616px;
            height: 130px;
            text-align: left;
            background: #F4F4F9;
            margin-top: 28px;
            border: 0px;
            border-radius: 6px;
            &-title {
                font-size: 22px;
                font-weight: 800;
                line-height: 22px;
                margin-left: 15px;
            }
            &-content {
                font-size: 16px;
                font-weight: 400;
                max-width: 576px;
                line-height: 26px;
                white-space: normal;
                margin-top: 16px;
                margin-left: 15px;
            }
        }
    }
}
</style>